import React from 'react';
import * as PropTypes from 'prop-types';

import s from './index.module.scss';
import SantaClausSignatureIcon from '../../../public/static/Gifts/images/santa-claus-signature.svg';

const SantaLetterTemplate = ({ name = '', present = '', postScriptum = '' }) => (
  <div className={s['bb-santa-letter__letter-template']}>
    <div className={s['bb-santa-letter__letter-text']}>
      <p>
        Dear{' '}
        <span className={s['bb-santa-letter__letter-value']}>
          {name ? name : "(your child's name)"}
        </span>
        ,
      </p>
      <p>
        Ho ho ho and a merry hello from my favourite spot in the North Pole! It's buzzing here in
        our workshop as we turn dreams into reality for children around the world.
      </p>
      <p>
        There are a lot of special things going on up here! Our glitter cannon, gift-wrapping robot
        and Chief Elf&#39;s carol singing comes to mind. But nothing in this crazy workshop is half
        as special as you are.
      </p>
      <p>
        You&#39;ve had such an amazing year being kind, clever and full of fun. We could use the
        likes of you up here, that&#39;s for sure! And that&#39;s why your name is at the top of the
        Nice List!
      </p>
      <p>
        Now about that{' '}
        <span className={s['bb-santa-letter__letter-value']}>
          {present ? present : '(super special toy)'}
        </span>{' '}
        you&#39;ve been dreaming of - it&#39;s all set up and ready to fly! We just had to rescue it
        from a pile of rubber ducks but that&#39;s a story for another day...
      </p>
      <p>
        Remember to get a good night&#39;s sleep on Christmas Eve, and if you hear any jingle bells,
        it&#39;s just the sound of extra magic in the air!
      </p>
      <p>With sleigh bells and sparkles,</p>
      <SantaClausSignatureIcon className={s['bb-santa-letter__letter-signature']} />
      <p>
        P.S.{' '}
        <span className={s['bb-santa-letter__letter-value']}>
          {postScriptum ? postScriptum : '(Add a personalised message for your child)'}
        </span>
      </p>
    </div>
  </div>
);

SantaLetterTemplate.propTypes = {
  name: PropTypes.string,
  present: PropTypes.string,
  postScriptum: PropTypes.string,
};

export default SantaLetterTemplate;
